import {DataFetcher} from '@aboutyou/data-fetcher';
import {useHistoryPageState} from '@aboutyou/history-page-state';
import {useInViewEffect} from '@aboutyou/ui-components';
import React, {RefObject} from 'react';
import {useRecommendations} from '../hooks/useRecommendations';
import {RecommendationsSkeleton} from './Recommendations.skeleton';
import {
  RecommendationsView,
  RecommendationsViewProps,
} from './RecommendationsView.eager';

export type RecommendationsProp = {
  addToBasketMethod?: 'flyout' | 'miniAdp';
} & Pick<RecommendationsViewProps, 'onClickAddToBasket' | 'compactMode'>;

const RECOMMENDATIONS_HISTORY_PAGE_STATE = 'RECOMMENDATIONS_HISTORY_PAGE_STATE';

export const Recommendations = (props: RecommendationsProp) => {
  const [inView, setInView] = useHistoryPageState(false, {
    uniqueKey: RECOMMENDATIONS_HISTORY_PAGE_STATE,
  });

  const handleInView = (isInView: boolean) => {
    if (isInView) {
      setInView(isInView);
    }
  };

  const {ref} = useInViewEffect(handleInView);

  return (
    <div ref={ref as RefObject<HTMLDivElement | null>}>
      <DataFetcher
        request={useRecommendations(inView)}
        Error={() => null}
        View={RecommendationsView}
        disableLoadingInIdleState
        Loading={RecommendationsSkeleton}
        viewProps={props}
      />
    </div>
  );
};
